import $ from 'jquery';

(function() { // Begin scoping function

  function updateBars() {

    // Set the breakpoint at which elements fade in (as a percentage of window height)
    const breakpoint = 30;

    // Find current window position
    const top_of_window = $(window).scrollTop();
    const bottom_of_window = $(window).scrollTop() + $(window).height();

    // For each element with the bar class...
    $('.panel-whats-inside-stats-nutrient-bottom-bar-fill').each(function() {

      const element_top = $(this).offset().top;

      // If the element is within fade-in range, mark it visible; otherwise, remove the visible class
      if (element_top + breakpoint <= bottom_of_window) {
        $(this).css('width', $(this).data('width'));
      } else {
        $(this).css('width', '0%');
      }

    });
  }

  // Run the updateFadeIns function on scroll
  $(window).bind('scroll', updateBars);
  $(window).bind('resize', updateBars);

  $(document).ready(() => {
    updateBars();
  });

})(); // End scoping function
